module.exports = __webpack_public_path__ + "_assets/img/app-logo.45d40197.svg";